import React, { Component } from 'react';
import { Button, Modal, DropdownButton, MenuItem } from 'react-bootstrap';
import languageList from './languageList.json';
import Config from '../../Config';
import axios from 'axios';
import md5 from 'react-native-md5';
import Toggle from 'react-bootstrap-toggle';
import ReactLoading from 'react-loading';
import translate from '../i18next/i18next';
import _ from 'lodash';
import Helper from '../common/Helper';
import imgPlanFree from '../../assets/images/img_plan_free.svg';
import imgPlanBasic from '../../assets/images/img_plan_basic.svg';
import imgPlanPremium from '../../assets/images/img_plan_premium.svg';
import imgPlanPro from '../../assets/images/img_plan_pro.svg';
import imgPlanLite from '../../assets/images/img_plan_lite.svg';
import imgPlanProPlus from '../../assets/images/img_plan_pro_plus.svg';
import imgRedemptionCode from '../../assets/images/img_redemption_code.svg';
import imgHelp from '../../assets/images/help.svg';

const countryList = window.countryList;
const deviceIcons = window.deviceIcons;

const DEVICE_HAS_DIFF_GEN = ['DCS-8000LH', 'DCS-8100LH'];

class Profile extends Component {
  constructor(props) {
    super(props);

    // refers to the subscription.settings.level
    this.skuPicTable = {
      '0': imgPlanFree,
      '1': imgPlanBasic,
      '2': imgPlanPremium,
      '3': imgPlanPro,
      '5': imgPlanLite,
      '6': imgPlanProPlus
    };

    this.state = {
      isLoading: true,
      email: '',
      country: 0,
      language: '',
      appLanguage: 'en',
      appLanguageDisplay: 'English',
      tempUser: {},
      user: {
        first_name: '',
        email: '',
        country: '',
        language: '',
        receive_news: false,
        active_policy: false,
        email_verified: 'loading'
      },
      newEmail: '',
      curPassword: '',
      newPassword: '',
      confirmPassword: '',
      isCurPasswordShow: false,
      isNewPasswordShow: false,
      isConfirmPasswordShow: false,
      downloadState: '',
      archive_pwd: '',
      isOpenChangeEmail: false,
      isOpenChangeEmailSuccess: false,
      isOpenChangePassword: false,
      isOpenDeleteAccount: false,
      isOpenDeleteSuccess: false,
      isShowPrivacyPolicy: false,
      isOpenDownloadAccount: false,
      isNameEdit: false,
      isLangEdit: false,
      isCountryEdit: false,
      isFormSubmitted: false,
      isEmailAlreadyExist: false,
      isInvalidPassword: false,
      isPreviousPassword: false,
      isPrivacyTab: 'privacy',
      deviceList: [],
      subscriptionList: [],
      countryList: countryList,
      languageList: languageList,
      isOpenRedeemActivationCode: false,
      isRedeemLoading: false,
      redeemCode: '',
      redeemResult: null,
      redeemErrorCode: null,
      isShowRedeemNotice: false,
      activationCodeList: [],
      expandedActivationCodeGroups: {}
    };
    if (!localStorage.getItem('dlinkuser')) {
      this.props.history.push('/');
      return;
    }
  }

  componentDidMount = () => {
    this.getUserInfo();
    this.getDeviceList();
    this.getArchiveStatus();
    const lang =
      this.props.language || localStorage.getItem('dlink-user-lang') || 'en';
    Config.curUser.lang = lang;
    this.changeLanguage(lang);
    window.scrollTo(0, 0);
  };

  componentDidUpdate = prevProps => {
    if (prevProps.language !== this.props.language) {
      this.changeLanguage(this.props.language);
    }
  };

  changeLanguage = lang => {
    localStorage.setItem('dlink-user-lang', lang);
    this.setState({
      appLanguage: lang,
      appLanguageDisplay: _.find(this.state.languageList, { code: lang }).name
    });
    Config.curUser.lang = lang;
    localStorage.setItem('dlinkuser', JSON.stringify(Config.curUser));
    this.getSubscriptionList(lang);
    this.getReservationList(lang);
  };

  handleCloseModal = () => {
    this.setState({
      isOpenChangeEmail: false,
      isOpenChangeEmailSuccess: false,
      isOpenChangePassword: false,
      isOpenDeleteAccount: false,
      isShowPrivacyPolicy: false,
      isOpenDeleteSuccess: false,
      isOpenDownloadAccount: false,
      isOpenRedeemActivationCode: false,
      isRedeemLoading: false,
      redeemCode: '',
      redeemResult: null,
      redeemErrorCode: null
    });
  };

  getUserInfo = () => {
    const { setUserInfo } = this.props;

    this.setState({ isLoading: true });
    axios
      .get(Config.baseUrl + 'me/user/info', {
        params: {
          access_token: Config.curUser.access_token
        }
      })
      .then(response => {
        if (response.data && response.data.data) {
          var _userInfo = response.data.data;

          // set user name to userContext
          setUserInfo(_userInfo.first_name, _userInfo.email);
          this.setState({
            user: _userInfo,
            tempUser: _userInfo
          });
          if (
            Config.curUser.privacy_policy === '0' ||
            Config.curUser.tos === '0'
          ) {
            this.showPrivacyPolicyModal();
          }
        }
        this.setState({ isLoading: false });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        localStorage.removeItem('dlinkuser');
        this.props.history.push('/');
      });
  };

  getDeviceList = () => {
    /*axios.get('https://d1vzklxl368c7b.cloudfront.net/portal/account_portal_devices.json').then(response => {
      if(response && response.data) {
      }
    }).catch(error => {
      console.log(error);
    });*/

    axios
      .get(Config.baseUrl + 'me/device/list', {
        params: {
          access_token: Config.curUser.access_token
        }
      })
      .then(response => {
        if (response.data && response.data.data) {
          this.setState({
            deviceList: response.data.data
          });
        }
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
      });
  };

  updateUserProfile = (_postURL, _inputData) => {
    axios
      .post(_postURL, JSON.stringify(_inputData))
      .then(response => {
        this.setState({
          tempUser: this.state.user,
          isNameEdit: false,
          isLangEdit: false,
          isCountryEdit: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
      });
  };

  updateName = () => {
    this.setState({
      user: {
        ...this.state.user,
        first_name: this.state.user.first_name.trim()
      }
    });

    if (/^\s+$/.test(this.state.user.first_name)) {
      // console.log('regexpt...');
      this.setState({
        user: {
          ...this.state.user,
          first_name: ''
        }
      });
      return;
    }

    if (!this.state.user.first_name) return;
    let inputData = {
      data: {
        email: this.state.user.email,
        first_name: this.state.user.first_name
      }
    };

    if (this.state.tempUser.first_name === this.state.user.first_name) {
      this.setState({
        isNameEdit: false
      });
      return;
    }

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/update?access_token=' +
      Config.curUser.access_token;
    //this.updateUserProfile(postURL, inputData);
    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        // set user name to userContext
        const { setUserInfo } = this.props;
        const { first_name, email } = this.state.user;
        setUserInfo(first_name, email);

        this.setState({
          tempUser: {
            ...this.state.tempUser,
            first_name: this.state.user.first_name
          },
          isNameEdit: false,
          isLoading: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  resetName = () => {
    const user = {
      ...this.state.user,
      first_name: this.state.tempUser.first_name
    };

    this.setState({
      user,
      isNameEdit: false
    });
  };

  updateLanguage = () => {
    if (!this.state.user.language) return;
    let inputData = {
      data: {
        email: this.state.user.email,
        language: this.state.user.language
      }
    };

    if (this.state.tempUser.language === this.state.user.language) {
      this.setState({
        isLangEdit: false
      });
      return;
    }

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/update?access_token=' +
      Config.curUser.access_token;

    //this.updateUserProfile(postURL, inputData);
    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        this.setState({
          tempUser: {
            ...this.state.tempUser,
            language: this.state.user.language
          },
          isLangEdit: false,
          isLoading: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  updateCountry = () => {
    if (!this.state.user.country) return;
    let inputData = {
      data: {
        email: this.state.user.email,
        country: this.state.user.country
      }
    };

    if (this.state.tempUser.country === this.state.user.country) {
      this.setState({
        isCountryEdit: false
      });
      return;
    }
    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/update?access_token=' +
      Config.curUser.access_token;
    //this.updateUserProfile(postURL, inputData);
    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        this.setState({
          tempUser: {
            ...this.state.tempUser,
            country: this.state.user.country
          },
          isCountryEdit: false,
          isLoading: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  handleChanges = event => {
    this.setState({
      [event.target.name]: event.target.value,
      isEmailAlreadyExist: false,
      isInvalidPassword: false,
      isPreviousPassword: false
    });
  };

  handleUserChanges = event => {
    // console.log(event.target.name);
    /*For checkboxes*/
    if (event.target.name === 'active_policy') {
      this.setState({
        user: {
          ...this.state.user,
          [event.target.name]: event.target.checked
        }
      });
      return;
    }

    /*Spread Operator*/
    this.setState({
      user: {
        ...this.state.user,
        [event.target.name]: event.target.value
      }
    });
  };

  handleUserCustomSelect = (key, value) => {
    this.setState(
      {
        user: {
          ...this.state.user,
          [key]: value
        }
      },
      function() {
        if (key === 'language') {
          this.updateLanguage();
        }
        if (key === 'country') {
          this.updateCountry();
        }
      }
    );
  };

  updateProfileSettings = () => {
    console.log(this.state);
  };

  doLogout = event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    axios
      .get(Config.baseUrl + 'oauth/revoke', {
        params: {
          client_id: Config.clientId,
          access_token: Config.curUser.access_token,
          revoke_type: 'token'
        }
      })
      .then(response => {
        this.handleCloseModal();
        localStorage.removeItem('dlinkuser');
        window.location.href =
          Config.oauthUrl +
          '?client_id=' +
          Config.clientId +
          '&redirect_uri=' +
          Config.redirectUrl +
          '&response_type=token&scope=basic&state=&hint=&lang=' +
          Config.curUser.lang;
      })
      .catch(error => {
        this.handleCloseModal();
        localStorage.removeItem('dlinkuser');
        window.location.href =
          Config.oauthUrl +
          '?client_id=' +
          Config.clientId +
          '&redirect_uri=' +
          Config.redirectUrl +
          '&response_type=token&scope=basic&state=&hint=&lang=' +
          Config.curUser.lang;
      });
  };

  showChangeEmailModal = () => {
    this.setState({
      isOpenChangeEmail: true,
      newEmail: '',
      curPassword: '',
      isFormSubmitted: false,
      isCurPasswordShow: false
    });
  };

  isInvalidEmail = event => {
    // console.log(this.state.appLanguage);
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      this.state.newEmail.length &&
      !re.test(String(this.state.newEmail).toLowerCase())
    )
      return (
        <div className="error"> {translate.t('enterValidEmail', 'cs')}</div>
      );
    else return null;
  };

  doChangeEmail = event => {
    event.preventDefault();

    this.setState({ isFormSubmitted: true });

    if (!this.state.curPassword || !this.state.newEmail) return;

    let inputData = {
      data: {
        email: this.state.newEmail,
        password: md5.hex_md5(this.state.curPassword)
      }
    };

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/change_email?access_token=' +
      Config.curUser.access_token;

    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        this.setState({
          isOpenChangeEmail: false,
          isOpenChangeEmailSuccess: true,
          isLoading: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        console.log(err);
        if (err.message === 'Account existed.')
          this.setState({ isEmailAlreadyExist: true });
        else if (err.message === 'User denied.')
          this.setState({ isInvalidPassword: true });
        else console.log(err.message);
        this.setState({ isLoading: false });
      });
  };

  gotoLoginPage = () => {
    this.handleCloseModal();
    localStorage.removeItem('dlinkuser');
    //this.props.history.push('/');
    window.location.href =
      Config.oauthUrl +
      '?client_id=' +
      Config.clientId +
      '&redirect_uri=' +
      Config.redirectUrl +
      '&response_type=token&scope=basic&state=&hint=&lang=' +
      Config.curUser.lang;
  };

  handleAjaxError = error => {
    if (error) {
      console.error(error.message);
      switch (error.code) {
        case 14: // InvalidToken
        case 101: // 2fa InvalidToken
          localStorage.removeItem('dlinkuser');
          this.gotoLoginPage();
          break;
        case 55: // new password the same with previous one
          break;
        default:
          console.error('Not handle code: ', error.code);
          break;
      }
    }
  };

  showChangePasswordModal = () => {
    this.setState({
      isOpenChangePassword: true,
      curPassword: '',
      newPassword: '',
      confirmPassword: '',
      isFormSubmitted: false,
      isCurPasswordShow: false,
      isNewPasswordShow: false,
      isConfirmPasswordShow: false
    });
  };

  checkNewPassword = password => {
    // Define a regular expression to match the password pattern
    const passwordPattern = /^(?=(.*\d){2})(?=.*[A-Z])(?=.*[!@#$&\W_])[!-~]{8,30}$/;

    // Test the password against the pattern and return the result
    return passwordPattern.test(password);
  };

  doChangePassword = event => {
    event.preventDefault();

    this.setState({ isFormSubmitted: true });

    if (this.state.curPassword === this.state.newPassword) {
      this.setState({ isPreviousPassword: true });
      return;
    }
    if (
      !this.state.curPassword ||
      !this.state.newPassword ||
      !this.state.confirmPassword
    )
      return;
    if (this.state.newPassword.length < 8) return;
    if (this.state.newPassword !== this.state.confirmPassword) return;
    if (!this.checkNewPassword(this.state.newPassword)) return;
    if (
      this.state.newPassword.toLowerCase() ===
        this.state.user.email.toLowerCase() ||
      this.state.newPassword.toLowerCase() ===
        this.state.user.email
          .substring(0, this.state.user.email.indexOf('@'))
          .toLowerCase()
    )
      return;

    let inputData = {
      data: {
        password: md5.hex_md5(this.state.curPassword),
        new_password: this.state.newPassword
      }
    };

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/change_password?access_token=' +
      Config.curUser.access_token;

    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        // console.log(response);
        this.setState({ isOpenChangePassword: false });
        this.gotoLoginPage();
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        if (err.message === 'User denied.')
          this.setState({ isInvalidPassword: true });
        else if (err.code === 55) this.setState({ isPreviousPassword: true });
        else console.log(err.message);
        this.setState({ isLoading: false });
      });
  };

  onToggleReceiveNews = () => {
    let inputData = {
      data: {
        email: this.state.user.email,
        receive_news: !this.state.user.receive_news
      }
    };

    this.setState({
      user: {
        ...this.state.user,
        receive_news: !this.state.user.receive_news
      }
    });
    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/update?access_token=' +
      Config.curUser.access_token;
    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        this.setState({
          tempUser: {
            ...this.state.tempUser,
            receive_news: this.state.user.receive_news
          },
          isLoading: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  showDeleteAccountModal = () => {
    this.setState({
      isFormSubmitted: false,
      isOpenDeleteAccount: true,
      curPassword: '',
      isCurPasswordShow: false
    });
  };

  doDeleteAccount = event => {
    event.preventDefault();
    this.setState({ isFormSubmitted: true });
    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/delete/request?access_token=' +
      Config.curUser.access_token;

    axios({
      method: 'POST',
      url: postURL,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
      .then(response => {
        this.setState({
          isLoading: false,
          isOpenDeleteAccount: false
        });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  showPrivacyPolicyModal = () => {
    this.setState({ isShowPrivacyPolicy: true });
  };

  doUpdatePrivacyPolicy = event => {
    let inputData = {
      data: {
        email: this.state.user.email,
        active_policy: this.state.user.active_policy,
        privacy_policy_agree: this.state.user.active_policy,
        tos_agree: this.state.user.active_policy
      }
    };

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/user/update?access_token=' +
      Config.curUser.access_token;
    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        this.setState({
          tempUser: {
            ...this.state.tempUser,
            active_policy: this.state.user.active_policy
          }
        });
        Config.curUser.privacy_policy = '1';
        Config.curUser.tos = '1';
        localStorage.setItem('dlinkuser', JSON.stringify(Config.curUser));
        this.setState({ isShowPrivacyPolicy: false, isLoading: false });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
        this.setState({ isLoading: false });
      });
  };

  showDownloadAccountModal = () => {
    this.setState({
      isOpenDownloadAccount: true,
      isFormSubmitted: false,
      curPassword: '',
      isCurPasswordShow: false
    });
  };

  getArchiveStatus = () => {
    var postURL =
      Config.baseUrl +
      'me/pack/get?access_token=' +
      Config.curUser.access_token;

    axios
      .get(postURL, { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } })
      .then(response => {
        if (response.data && response.data.data) {
          this.setState({
            downloadState: response.data.data.state,
            archive_pwd: response.data.data.archive_pwd
              ? response.data.data.archive_pwd
              : '',
            isLoading: false
          });
        }
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
      });
  };

  doArchiveAccount = event => {
    event.preventDefault();
    this.setState({ isFormSubmitted: true });

    let inputData = {
      data: {
        password: md5.hex_md5(this.state.curPassword)
      }
    };

    this.setState({ isLoading: true });
    var postURL =
      Config.baseUrl +
      'me/pack/add?access_token=' +
      Config.curUser.access_token;

    axios({
      method: 'POST',
      url: postURL,
      data: JSON.stringify(inputData),
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
      .then(response => {
        if (
          response.data &&
          response.data.data &&
          response.data.data.result === true
        ) {
          this.setState({ downloadState: 0 });
        }
        this.setState({ isOpenDownloadAccount: false, isLoading: false });
      })
      .catch(error => {
        if (!error.response) {
          this.setState({ isInvalidPassword: true, isLoading: false });
          return;
        }
        var err = error.response.data.error;
        this.handleAjaxError(err);
        if (err.message === 'User denied.')
          this.setState({ isInvalidPassword: true });
        else console.log(err.message);
        this.setState({ isLoading: false });
      });
  };

  downloadArchive = event => {
    event.preventDefault();
    var postURL =
      Config.baseUrl +
      'me/pack/download?access_token=' +
      Config.curUser.access_token;
    axios
      .get(postURL, { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } })
      .then(response => {
        if (response.data && response.data.data && response.data.data.url) {
          window.location.href = response.data.data.url;
        }

        this.setState({ isLoading: false });
      })
      .catch(error => {
        if (!error.response) return;
        var err = error.response.data.error;
        this.handleAjaxError(err);
      });
  };

  getSubscriptionList = (lang = this.state.appLanguage) => {
    const postURL =
      Config.baseUrl +
      'me/billing/subscription/list?access_token=' +
      Config.curUser.access_token;
    const inputData = { data: { active: true, lang } };

    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        if (!response.data || !response.data.data) return;
        const subscriptionList = response.data.data
          .filter(item => item.vendor_id === 1)
          .slice(0, 1);
        this.setState({ subscriptionList });
      })
      .catch(error => {
        if (!error.response) return;
        this.handleAjaxError(error.response.data.error);
      });
  };

  getReservationList = (lang = this.state.appLanguage) => {
    const postURL =
      Config.baseUrl +
      'v3/billing/reservation/list?access_token=' +
      Config.curUser.access_token;
    const inputData = { data: { store: 'subLicense', lang } };

    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        if (!response.data || !response.data.data) return;
        this.setState({ activationCodeList: response.data.data });
      })
      .catch(error => {
        if (!error.response) return;
        this.handleAjaxError(error.response.data.error);
      });
  };

  doRedeemActivationCode = () => {
    this.setState({ isRedeemLoading: true });
    const postURL =
      Config.baseUrl +
      'v3/billing/license/use?access_token=' +
      Config.curUser.access_token;
    const inputData = { data: { redeemCode: this.state.redeemCode } };
    const redeemCodeLength = this.state.redeemCode.length;
    const canRedeem =
      redeemCodeLength >= 12 &&
      redeemCodeLength <= 21 &&
      !this.state.isRedeemLoading;

    if (!canRedeem) {
      this.setState({
        isRedeemLoading: false,
        redeemResult: 'error',
        redeemErrorCode: true // set true to show default error message
      });
      return;
    }

    axios
      .post(postURL, JSON.stringify(inputData), {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(() => {
        this.getSubscriptionList();
        this.getReservationList();
        this.setState({
          isRedeemLoading: false,
          redeemResult: 'success',
          redeemErrorCode: null
        });
      })
      .catch(error => {
        var err =
          error && error.response && error.response.data
            ? error.response.data.error
            : null;
        if (err) this.handleAjaxError(err);
        this.setState({
          isRedeemLoading: false,
          redeemResult: 'error',
          redeemErrorCode: err ? err.code : null
        });
      });
  };

  submitRedeemActivationCode = event => {
    event.preventDefault();
    this.doRedeemActivationCode();
  };

  copyToClipboard = event => {
    event.preventDefault();
    var textField = document.createElement('textarea');
    textField.innerText = this.state.archive_pwd;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  };

  render() {
    const { language } = this.props;
    let lng = language || this.state.appLanguage;
    const {
      user,
      languageList,
      subscriptionList,
      activationCodeList
    } = this.state;
    const userLangCode = user.language;
    let userLang = '';
    const enrichedActivationCodeList = activationCodeList
      .map(item => ({
        ...item,
        redeem_code: item.raw_data && item.raw_data.redeem_code
      }))
      .sort((a, b) => {
        const orderDiff = (a.status === 1 ? 1 : 0) - (b.status === 1 ? 1 : 0);
        if (orderDiff !== 0) return orderDiff;
        return Number(b.created_at) - Number(a.created_at);
      });
    const privacyUrl =
      window.trusteInfo !== undefined
        ? window.trusteInfo.privacyUrl
        : 'https://d1rvtd08ngd4ef.cloudfront.net/new+mydlink/privacy_and_tos/privacy_policy_content.html?lang=';

    if (userLangCode) {
      languageList.some(item => {
        const isMatch = item.code.toLowerCase() === userLangCode.toLowerCase();

        if (isMatch) {
          userLang = item.name ? item.name : '';
        }

        return isMatch;
      });
    }

    return (
      <div className="page profile">
        {this.state.isLoading && (
          <div>
            <div className="fade modal-backdrop page-backdrop in" />
            <ReactLoading
              className="page-loader"
              type={'bubbles'}
              color={'#009dda'}
              height={70}
              width={70}
            />
          </div>
        )}

        <div className="main_content">
          <div className="account-wrapper">
            <h6>{translate.t('generalInformation', { lng })}</h6>
            <div className="account-form">
              <div className="general-info">
                <div className="account-group email">
                  <label>{translate.t('email', { lng })}</label>
                  <input type="text" value={this.state.user.email} />
                  {this.state.user.email_verified !== 'loading' &&
                    this.state.user.email_verified && (
                      <i className="fa fa-check" />
                    )}
                  {this.state.user.email_verified !== 'loading' &&
                    !this.state.user.email_verified && (
                      <i
                        className="fa fa-exclamation-circle"
                        aria-hidden="true"
                      />
                    )}
                  <div className="change-info">
                    {this.state.user.email_verified !== 'loading' &&
                      !this.state.user.email_verified && (
                        <span className="text-right error">
                          {translate.t('accountNotVerified', { lng })}
                        </span>
                      )}
                    <Button
                      className="btn btn-outline-secondary btn-xs"
                      onClick={this.showChangeEmailModal}
                    >
                      {translate.t('changeEmail', { lng })}
                    </Button>
                    <Button
                      className="btn btn-outline-secondary btn-xs"
                      onClick={this.showChangePasswordModal}
                    >
                      {translate.t('changePassword', { lng })}
                    </Button>
                  </div>
                </div>
                <div className="account-group">
                  <label>{translate.t('userName', { lng })}</label>
                  <input
                    type="text"
                    name="first_name"
                    // ref="first_name"
                    value={this.state.user.first_name}
                    onChange={this.handleUserChanges}
                    readOnly={this.state.isNameEdit ? false : true}
                    autoComplete="off"
                    maxLength="30"
                    pattern="[a-z]{1,15}"
                  />

                  {this.state.isNameEdit &&
                  !this.state.user.first_name.length ? (
                    <div className="text-right error">
                      {translate.t('nameIsRequired', { lng })}
                    </div>
                  ) : (
                    ''
                  )}
                  {!this.state.isNameEdit ? (
                    <i
                      className="fa fa-pencil"
                      onClick={() => {
                        this.setState({ isNameEdit: true });
                      }}
                    />
                  ) : (
                    ''
                  )}
                  {this.state.isNameEdit ? (
                    <i className="fa fa-check" onClick={this.updateName} />
                  ) : (
                    ''
                  )}
                  {this.state.isNameEdit ? (
                    <i className="fa fa-close" onClick={this.resetName} />
                  ) : (
                    ''
                  )}
                </div>
                <div className="account-group select mobile-select custom topMargin">
                  <label>{translate.t('language', { lng })}</label>
                  <DropdownButton
                    bsStyle="primary"
                    title={userLang}
                    name="language"
                    id="language-dropdown"
                    className={`btn btn-outline-secondary btn-xs delete btn btn-default language`}
                  >
                    {this.state.languageList.map((item, index) => {
                      return (
                        <MenuItem
                          active={
                            userLangCode.toLowerCase() ===
                            item.code.toLowerCase()
                          }
                          onClick={e => {
                            this.handleUserCustomSelect('language', item.code);
                          }}
                          key={index}
                        >
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </DropdownButton>
                  <input
                    type="text"
                    name="language"
                    value={userLang}
                    readOnly={true}
                  />
                </div>
                <div className="account-group select custom topMargin mobile-select">
                  <label>{translate.t('country', { lng })}</label>
                  <DropdownButton
                    bsStyle="primary"
                    title={
                      this.state.user.country
                        ? _.find(this.state.countryList, {
                            code: this.state.user.country
                          }).name
                        : ''
                    }
                    name="country"
                    id="country-dropdown"
                    className={`btn btn-outline-secondary btn-xs delete btn btn-default language`}
                  >
                    {this.state.countryList.map((item, index) => {
                      return (
                        <MenuItem
                          active={this.state.user.country === item.code}
                          onClick={e => {
                            this.handleUserCustomSelect('country', item.code);
                          }}
                          key={index}
                        >
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </DropdownButton>
                  <input
                    type="text"
                    name="country"
                    value={
                      this.state.user.country
                        ? this.state.countryList.filter(
                            e => e.code === this.state.user.country
                          )[0].name
                        : ''
                    }
                    readOnly={this.state.isCountryEdit ? false : true}
                  />
                </div>
                <div className="account-group clearfix bottom-brd topMargin">
                  <label>
                    {translate.t('receiveTheLatestProductInformation', { lng })}
                  </label>
                  <input
                    type="text"
                    name="receive_news"
                    value={this.state.user.receive_news}
                    readOnly="true"
                    className="receive_news_txt"
                  />
                  <div className="pull-right-top">
                    <Toggle
                      onClick={this.onToggleReceiveNews}
                      on={
                        <span className="yes">
                          {translate.t('yes', { lng })}
                        </span>
                      }
                      off={
                        <span className="no">{translate.t('No', { lng })}</span>
                      }
                      size="xs"
                      offstyle="primary"
                      active={this.state.user.receive_news}
                    />
                  </div>
                </div>
              </div>
              <div className="user-right topMargin">
                <h6>{translate.t('userRight', { lng })}</h6>
                <div className="account-group topMargin bottom-brd">
                  <label>{translate.t('deleteAccount', { lng })}</label>
                  <input type="text" readOnly />
                  <Button
                    className="btn btn-outline-secondary btn-xs delete"
                    onClick={this.showDeleteAccountModal}
                  >
                    {translate.t('delete', { lng })}
                  </Button>
                </div>
                <div className="account-group clearfix topMargin">
                  <div className="bottom-brd">
                    <label>{translate.t('downloadUserData', { lng })}</label>
                    <input type="text" readOnly />
                    {this.state.downloadState === -1 && (
                      <Button
                        className="btn btn-outline-secondary btn-xs delete"
                        onClick={this.doArchiveAccount}
                      >
                        {translate.t('download', { lng })}
                      </Button>
                    )}
                    {this.state.downloadState === 0 && (
                      <Button
                        className="btn btn-outline-secondary btn-xs delete download"
                        disabled
                      >
                        {translate.t('download', { lng })}
                      </Button>
                    )}
                    {this.state.downloadState === 0 && (
                      <p className="info">
                        {translate.t('downloadModal.downloadProcess', { lng })}
                      </p>
                    )}
                    {this.state.downloadState === 1 && (
                      <Button
                        className="btn btn-outline-secondary btn-xs delete orange"
                        onClick={this.downloadArchive}
                      >
                        {translate.t('getYourData', { lng })}
                      </Button>
                    )}
                  </div>
                  {this.state.downloadState === 1 && (
                    <p className="info black">
                      {' '}
                      {translate.t('downloadModal.downloadClick', { lng })}{' '}
                      &nbsp;
                      <span className="archive_pwd">
                        {this.state.archive_pwd}
                      </span>
                      <Button
                        className="btn btn-outline-secondary btn-xs copy copy-password"
                        onClick={this.copyToClipboard}
                      >
                        {translate.t('copy', { lng })}
                      </Button>
                    </p>
                  )}
                </div>
              </div>

              <div className="subscription-list topMargin">
                <h6>
                  {translate.t('subscription.title', { lng })}
                  <span className="help-icon-wrap">
                    <img
                      src={imgHelp}
                      alt="help"
                      className="help-icon"
                      onClick={() =>
                        this.setState({ isShowRedeemNotice: true })
                      }
                    />
                  </span>
                </h6>
                {subscriptionList.length > 0 && (
                  <label className="subscription-subtitle">
                    {translate.t('subscription.subTitle', { lng })}
                  </label>
                )}
                {subscriptionList.map((item, index) => {
                  const formattedDate = Helper.formatDate(
                    item.expire_date * 1000
                  );
                  const level =
                    item.settings && item.settings.level !== undefined
                      ? String(item.settings.level)
                      : null;
                  const planImg =
                    level !== null ? this.skuPicTable[level] : null;
                  return (
                    <div key={index} className="subscription-item">
                      <div className="subscription-icon">
                        {planImg && <img src={planImg} alt={item.name} />}
                      </div>
                      <div className="subscription-info">
                        <p className="subscription-name basic-blue">
                          {item.name}
                        </p>
                        <p className="subscription-desc">
                          {translate.t('subscription.subMessage', { lng })}
                        </p>
                      </div>
                      <div className="subscription-expire">
                        <span>
                          {translate.t('subscription.expirationDate', { lng })}
                        </span>
                        <strong>{formattedDate}</strong>
                      </div>
                    </div>
                  );
                })}
              </div>

              {enrichedActivationCodeList.length > 0 && (
                <div className="activation-code-list topMargin">
                  <h6>{translate.t('activationCode.title', { lng })}</h6>
                  {['active', 'activated', 'redeemed'].map(groupKey => {
                    const activeSid =
                      subscriptionList[0] && subscriptionList[0].sid;
                    const group = enrichedActivationCodeList.filter(i => {
                      if (groupKey === 'active')
                        return (
                          i.status === 1 &&
                          activeSid &&
                          i.related_sid === activeSid
                        );
                      if (groupKey === 'activated')
                        return (
                          i.status === 1 &&
                          !(activeSid && i.related_sid === activeSid)
                        );
                      return i.status !== 1;
                    });
                    if (group.length === 0) return null;
                    const isExpanded = !!this.state
                      .expandedActivationCodeGroups[groupKey];
                    const label = translate.t(
                      `activationCode.${groupKey}Label`,
                      { lng }
                    );
                    const desc = translate.t(`activationCode.${groupKey}Desc`, {
                      lng
                    });
                    return (
                      <div key={groupKey} className="activation-code-group">
                        <div
                          className="activation-code-group-header"
                          onClick={() =>
                            this.setState(prev => ({
                              expandedActivationCodeGroups: {
                                ...prev.expandedActivationCodeGroups,
                                [groupKey]: !prev.expandedActivationCodeGroups[
                                  groupKey
                                ]
                              }
                            }))
                          }
                        >
                          <span className="activation-code-group-count active">
                            {group.length}
                          </span>
                          <span className="activation-code-group-label">
                            {label}
                          </span>
                          <span className="activation-code-group-desc">
                            {desc}
                          </span>
                          <i
                            className={`fa activation-code-group-toggle ${
                              isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
                            }`}
                          />
                        </div>
                        <div
                          className={`activation-code-group-detail${
                            isExpanded ? ' expanded' : ''
                          }`}
                        >
                          {group.map((item, index) => {
                            const level =
                              item.sku_settings &&
                              item.sku_settings.level !== undefined
                                ? String(item.sku_settings.level)
                                : null;
                            const planImg =
                              level !== null ? this.skuPicTable[level] : null;
                            return (
                              <div
                                key={index}
                                className="activation-code-detail-item"
                              >
                                <div className="activation-code-detail-icon">
                                  {planImg && (
                                    <img src={planImg} alt={item.sku_name} />
                                  )}
                                </div>
                                <div className="activation-code-detail-info">
                                  <p className="activation-code-sku-name basic-blue">
                                    {item.sku_name}
                                  </p>
                                  <div className="activation-code-detail-fields">
                                    {item.activated_at && (
                                      <div className="activation-code-detail-field">
                                        <span className="activation-code-field-label">
                                          {translate.t(
                                            'activationCode.activatedAt',
                                            {
                                              lng
                                            }
                                          )}
                                        </span>
                                        <span className="activation-code-field-value">
                                          {Helper.formatTime(item.activated_at)}
                                        </span>
                                      </div>
                                    )}
                                    <div className="activation-code-detail-field">
                                      <span className="activation-code-field-label">
                                        {translate.t(
                                          'activationCode.redeemedAt',
                                          {
                                            lng
                                          }
                                        )}
                                      </span>
                                      <span className="activation-code-field-value">
                                        {item.created_at
                                          ? Helper.formatTime(item.created_at)
                                          : '-'}
                                      </span>
                                    </div>
                                    <div className="activation-code-detail-field">
                                      <span className="activation-code-field-label">
                                        {translate.t(
                                          'activationCode.activationCode',
                                          {
                                            lng
                                          }
                                        )}
                                      </span>
                                      <span className="activation-code-field-value">
                                        {item.redeem_code || '-'}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <Button
                className="btn-primary button-blue btn btn-default margin-top20"
                onClick={() =>
                  this.setState({ isOpenRedeemActivationCode: true })
                }
              >
                {translate.t('redeemActivationCode', { lng })}
              </Button>

              <div className="device-list topMargin">
                <h6>{translate.t('yourDevices', { lng })}</h6>
                <table className="table">
                  <thead>
                    <tr>
                      <th>{translate.t('devices', { lng })}</th>
                      <th>{translate.t('modelName', { lng })}</th>
                      <th>{translate.t('app', { lng })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.deviceList.map((item, index) => {
                      const gen = item.gen;
                      const deviceModel = item.device_model;
                      let deviceConfigModel = deviceModel;

                      if (
                        DEVICE_HAS_DIFF_GEN.indexOf(deviceModel) !== -1 &&
                        gen === 2
                      ) {
                        deviceConfigModel = `${deviceModel}_GEN2`;
                      }
                      return (
                        <tr key={index}>
                          <td>
                            <img
                              alt={deviceModel}
                              title={deviceModel}
                              src={
                                deviceIcons.Device[deviceConfigModel] &&
                                deviceIcons.Device[deviceConfigModel].deviceIcon
                              }
                            />
                          </td>
                          <td>
                            <p>{deviceModel}</p>
                            {item.mac}
                          </td>
                          <td>
                            <img
                              alt="D-Link"
                              title="D-Link"
                              src={
                                deviceIcons.app[
                                  deviceIcons.Device[deviceConfigModel] &&
                                    deviceIcons.Device[deviceConfigModel].app
                                ]
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                    {!this.state.deviceList.length && (
                      <tr>
                        <td colSpan="3" className="text-center">
                          {translate.t('noDevicesFound', { lng })}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.isOpenChangeEmail}
          onHide={this.handleCloseModal}
          keyboard={true}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {translate.t('emailChangeModal.title', { lng })}
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={this.doChangeEmail}>
            <Modal.Body>
              <p>{translate.t('emailChangeModal.message', { lng })}</p>
              <div className="form-group">
                <label>
                  {translate.t('emailChangeModal.currentEmail', { lng })}
                </label>
                <p>{this.state.tempUser.email}</p>
              </div>
              <div className="form-group">
                <label>
                  {translate.t('emailChangeModal.newEmail', { lng })}
                </label>
                <input
                  type="text"
                  name="newEmail"
                  value={this.state.newEmail}
                  onChange={this.handleChanges}
                  placeholder={translate.t('email', { lng })}
                />
                {this.state.isFormSubmitted && !this.state.newEmail.length ? (
                  <div className="error">
                    {translate.t('emailChangeModal.changeEmailError', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted &&
                this.state.isEmailAlreadyExist ? (
                  <div className="error">
                    {translate.t('emailChangeModal.changeEmailExist', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted && this.isInvalidEmail()}
              </div>
              <div className="form-group">
                <label>
                  {translate.t('emailChangeModal.currentPassword', { lng })}
                </label>
                <input
                  type={this.state.isCurPasswordShow ? 'text' : 'password'}
                  name="curPassword"
                  value={this.state.curPassword}
                  onChange={this.handleChanges}
                  maxLength="30"
                  placeholder={translate.t('password', { lng })}
                />
                {!this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye-slash eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: true });
                    }}
                  />
                )}
                {this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: false });
                    }}
                  />
                )}
                {this.state.isFormSubmitted &&
                !this.state.curPassword.length ? (
                  <div className="error">
                    {translate.t('emailChangeModal.changeEmailError', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted && this.state.isInvalidPassword ? (
                  <div className="error">
                    {translate.t('emailChangeModal.passwordError', { lng })}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-white" onClick={this.handleCloseModal}>
                {translate.t('emailChangeModal.changeEmailCancel', { lng })}
              </Button>

              <Button type="submit" className="btn-primary button-blue">
                {translate.t('emailChangeModal.changeEmailChange', { lng })}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal
          show={this.state.isOpenChangeEmailSuccess}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>
              {translate.t('emailChangeModal.changeEmail', { lng })}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{translate.t('emailChangeModal.changedMail', { lng })}</p>
            <p>{translate.t('emailChangeModal.emailVerify', { lng })}</p>
          </Modal.Body>
          <Modal.Footer className="text-center">
            <Button className="btn-primary" onClick={this.gotoLoginPage}>
              {translate.t('emailChangeModal.ok', { lng })}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.isOpenChangePassword}
          onHide={this.handleCloseModal}
          keyboard={true}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {translate.t('changePasswordModal.title', { lng })}
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={this.doChangePassword}>
            <Modal.Body>
              <p>{translate.t('changePasswordModal.message', { lng })}</p>
              <div className="form-group">
                <label>
                  {translate.t('changePasswordModal.currentPassword', { lng })}
                </label>
                <input
                  type={this.state.isCurPasswordShow ? 'text' : 'password'}
                  name="curPassword"
                  value={this.state.curPassword}
                  onChange={this.handleChanges}
                  maxLength="30"
                  placeholder={translate.t('password', { lng })}
                />
                {!this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye-slash eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: true });
                    }}
                  />
                )}
                {this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: false });
                    }}
                  />
                )}
                {this.state.isFormSubmitted && this.state.isInvalidPassword ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordIncorrect', {
                      lng
                    })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted &&
                !this.state.curPassword.length ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordIncorrect', {
                      lng
                    })}
                    {translate.t('changePasswordModal.passwordError', { lng })}
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="form-group">
                <label>
                  {translate.t('changePasswordModal.newPassword', { lng })}
                </label>
                <input
                  type={this.state.isNewPasswordShow ? 'text' : 'password'}
                  name="newPassword"
                  value={this.state.newPassword}
                  onChange={this.handleChanges}
                  maxLength="30"
                  placeholder={translate.t('password', { lng })}
                />
                {!this.state.isNewPasswordShow && (
                  <i
                    className="fa fa-eye-slash eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isNewPasswordShow: true });
                    }}
                  />
                )}
                {this.state.isNewPasswordShow && (
                  <i
                    className="fa fa-eye eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isNewPasswordShow: false });
                    }}
                  />
                )}
                {this.state.isFormSubmitted &&
                !this.state.newPassword.length ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordError', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted &&
                !this.checkNewPassword(this.state.newPassword) ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordChars', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted &&
                (this.state.newPassword.toLowerCase() ===
                  this.state.user.email.toLowerCase() ||
                  this.state.newPassword.toLowerCase() ===
                    this.state.user.email
                      .substring(0, this.state.user.email.indexOf('@'))
                      .toLowerCase()) ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordTheSameName', {
                      lng
                    })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted && this.state.isPreviousPassword ? (
                  <div className="error">
                    {translate.t(
                      'changePasswordModal.passwordTheSamePrevious',
                      {
                        lng
                      }
                    )}
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="form-group">
                <label>
                  {translate.t('changePasswordModal.confirmNewPassword', {
                    lng
                  })}
                </label>
                <input
                  type={this.state.isConfirmPasswordShow ? 'text' : 'password'}
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.handleChanges}
                  maxLength="30"
                  placeholder={translate.t('password', { lng })}
                />
                {!this.state.isConfirmPasswordShow && (
                  <i
                    className="fa fa-eye-slash eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isConfirmPasswordShow: true });
                    }}
                  />
                )}
                {this.state.isConfirmPasswordShow && (
                  <i
                    className="fa fa-eye eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isConfirmPasswordShow: false });
                    }}
                  />
                )}
                {this.state.isFormSubmitted &&
                !this.state.confirmPassword.length ? (
                  <div className="error">
                    {translate.t('changePasswordModal.passwordError', { lng })}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted &&
                (this.state.newPassword.length !==
                  this.state.confirmPassword.length ||
                  this.state.newPassword !== this.state.confirmPassword) ? (
                  <div className="error">
                    {translate.t('notVerifyPassword', { lng })}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-white" onClick={this.handleCloseModal}>
                {translate.t('changePasswordModal.changePasswordCancel', {
                  lng
                })}
              </Button>
              <Button type="submit" className="btn-primary button-blue">
                {translate.t('changePasswordModal.changePasswordChange', {
                  lng
                })}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal
          show={this.state.isOpenDeleteAccount}
          onHide={this.handleCloseModal}
          keyboard={true}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {translate.t('deleteAccountModal.title', { lng })}
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={this.doDeleteAccount}>
            <Modal.Body>
              <h6 className="red">
                {translate.t('deleteAccountModal.note', { lng })}
              </h6>
              <p>{translate.t('deleteAccountModal.message1', { lng })}</p>
              <p>{translate.t('deleteAccountModal.message2', { lng })}</p>
              <p>{translate.t('deleteAccountModal.message3', { lng })} </p>
              <h6 className="red">
                {translate.t('deleteAccountModal.message4', { lng })}{' '}
              </h6>
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-white" onClick={this.handleCloseModal}>
                {translate.t('deleteAccountModal.deleteAccountCancel', { lng })}
              </Button>
              <Button className="btn-primary button-blue" type="submit">
                {translate.t('deleteAccountModal.deleteAccountSend', { lng })}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal
          show={this.state.isOpenDeleteSuccess}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>
              {translate.t('deleteAccountModal.accountDeleted', { lng })}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{translate.t('deleteAccountModal.deleteSorry', { lng })}</p>
            <p> {translate.t('deleteAccountModal.thankYou', { lng })}</p>
          </Modal.Body>
          <Modal.Footer className="text-center">
            <Button className="btn-primary" onClick={this.gotoLoginPage}>
              {translate.t('deleteAccountModal.exit', { lng })}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="terms-modal"
          show={this.state.isShowPrivacyPolicy}
          onHide={this.handleCloseModal}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <Button
              onClick={() => {
                this.setState({ isPrivacyTab: 'privacy' });
              }}
              className={
                this.state.isPrivacyTab === 'privacy' ? 'btn-primary' : ''
              }
              type="submit"
            >
              {translate.t('privacyPolicy', { lng })}
            </Button>
            <Button
              onClick={() => {
                this.setState({ isPrivacyTab: 'terms' });
              }}
              className={
                this.state.isPrivacyTab === 'terms' ? 'btn-primary' : ''
              }
              type="submit"
            >
              {translate.t('termsOfUse', { lng })}
            </Button>
          </Modal.Header>
          <Modal.Body>
            {this.state.isPrivacyTab === 'privacy' && (
              <div className="terms-container">
                <iframe src={privacyUrl + lng} title="Privacy Policy" />
              </div>
            )}
            {this.state.isPrivacyTab === 'terms' && (
              <div className="terms-container">
                <iframe src={Config.termsOfUseUrl + lng} title="Terms of Use" />
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <div className="form-group">
              <label>
                <input
                  className="terms-check"
                  type="checkbox"
                  name="active_policy"
                  value={this.state.user.active_policy}
                  onChange={this.handleUserChanges}
                />
                {translate.t('termsPolicy', { lng })}
              </label>
            </div>
            <Button onClick={this.doLogout}>
              {translate.t('decline', { lng })}
            </Button>
            <Button
              onClick={this.doUpdatePrivacyPolicy}
              className="btn-primary"
              type="submit"
              disabled={!this.state.user.active_policy}
            >
              {translate.t('accept', { lng })}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.isOpenRedeemActivationCode}
          onHide={this.handleCloseModal}
          keyboard={true}
          backdrop="static"
        >
          {this.state.isRedeemLoading && (
            <div className="redeem-loading">
              <ReactLoading
                type="spin"
                color="#009DDA"
                height={50}
                width={50}
              />
            </div>
          )}
          {!this.state.isRedeemLoading && this.state.redeemResult === null && (
            <React.Fragment>
              <Modal.Header closeButton>
                <Modal.Title className="basic-blue">
                  <strong>{translate.t('redeemModal.title', { lng })}</strong>
                </Modal.Title>
              </Modal.Header>
              <form onSubmit={this.submitRedeemActivationCode}>
                <Modal.Body>
                  <p>{translate.t('redeemModal.message', { lng })}</p>
                  <div className="form-group">
                    <label>
                      <strong>
                        {translate.t('redeemModal.activationCodeLabel', {
                          lng
                        })}
                      </strong>
                    </label>
                    <input
                      type="text"
                      value={this.state.redeemCode}
                      onChange={e =>
                        this.setState({ redeemCode: e.target.value })
                      }
                      maxLength={30}
                      className="redeem-input"
                    />
                  </div>
                  <div className="redeem-image-placeholder">
                    <img src={imgRedemptionCode} alt="redemption code" />
                  </div>
                </Modal.Body>
                <Modal.Footer className="text-center">
                  <Button
                    type="submit"
                    className="btn-primary button-blue redeem-submit-btn"
                    disabled={this.state.redeemCode.length < 12}
                  >
                    {translate.t('redeemModal.redeemBtnTitle', { lng })}
                  </Button>
                </Modal.Footer>
              </form>
            </React.Fragment>
          )}
          {!this.state.isRedeemLoading &&
            this.state.redeemResult === 'success' && (
              <React.Fragment>
                <Modal.Header>
                  <Modal.Title>
                    {translate.t('redeemModal.successTitle', { lng })}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>{translate.t('redeemModal.successMessage', { lng })}</p>
                </Modal.Body>
                <Modal.Footer className="text-center">
                  <Button
                    className="btn-primary button-blue"
                    onClick={this.handleCloseModal}
                  >
                    {translate.t('redeemModal.closeBtnTitle', { lng })}
                  </Button>
                </Modal.Footer>
              </React.Fragment>
            )}
          {!this.state.isRedeemLoading && this.state.redeemResult === 'error' && (
            <React.Fragment>
              <Modal.Header>
                <Modal.Title className="basic-blue">
                  <strong>
                    {translate.t('redeemModal.redeemErrorTitle', { lng })}
                  </strong>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  {this.state.redeemErrorCode === 212
                    ? translate.t('redeemError.used', { lng })
                    : translate.t('redeemError.failed', { lng })}
                </p>
              </Modal.Body>
              <Modal.Footer className="text-center">
                <Button
                  className="btn-primary button-blue"
                  onClick={this.handleCloseModal}
                >
                  {translate.t('redeemModal.closeBtnTitle', { lng })}
                </Button>
              </Modal.Footer>
            </React.Fragment>
          )}
        </Modal>

        <Modal
          show={this.state.isOpenDownloadAccount}
          onHide={this.handleCloseModal}
          keyboard={true}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {translate.t('downloadModal.title', { lng })}
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={this.doArchiveAccount}>
            <Modal.Body>
              <p>{translate.t('downloadModal.note', { lng })}</p>
              <div className="form-group">
                <label>
                  {translate.t('downloadModal.accountPassword', { lng })}
                </label>
                <input
                  type={this.state.isCurPasswordShow ? 'text' : 'password'}
                  name="curPassword"
                  value={this.state.curPassword}
                  onChange={this.handleChanges}
                  maxLength="30"
                  placeholder={translate.t('password', { lng })}
                />
                {!this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye-slash eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: true });
                    }}
                  />
                )}
                {this.state.isCurPasswordShow && (
                  <i
                    className="fa fa-eye eye"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState({ isCurPasswordShow: false });
                    }}
                  />
                )}
                {this.state.isFormSubmitted &&
                !this.state.curPassword.length ? (
                  <div className="error">
                    {translate.t('downloadModal.downloadError', { lng })}{' '}
                  </div>
                ) : (
                  ''
                )}
                {this.state.isFormSubmitted && this.state.isInvalidPassword ? (
                  <div className="error">
                    {translate.t('downloadModal.downloadPasswordError', {
                      lng
                    })}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-white" onClick={this.handleCloseModal}>
                {translate.t('downloadModal.downloadCancel', { lng })}
              </Button>
              <Button className="btn-primary button-blue" type="submit">
                {translate.t('downloadModal.downloadSend', { lng })}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        <Modal
          show={this.state.isShowRedeemNotice}
          onHide={() => this.setState({ isShowRedeemNotice: false })}
          keyboard={true}
          backdrop={true}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <ul className="redeem-notice-list">
              <li>{translate.t('redeemNotice.notice1', { lng })}</li>
              <li>{translate.t('redeemNotice.notice2', { lng })}</li>
              <li>{translate.t('redeemNotice.notice3', { lng })}</li>
              <li>{translate.t('redeemNotice.notice4', { lng })}</li>
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-primary button-blue"
              onClick={() => this.setState({ isShowRedeemNotice: false })}
            >
              {translate.t('redeemModal.closeBtnTitle', { lng })}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/profile/Profile.js